import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { RouteDivertApprovaldataModel } from '../../model'
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-routedivertapproval',
  template: require('./routedivertapproval.component.html'),
  styles: []
})
export class RouteDivertApprovalComponent implements OnInit {

  EmpDetails: any;
  private columnDefs;
  private rowHeight;
  private rowData;
  firstDate: any;
  lastDate: any;
  api: any;
  busy: Subscription;
  columnApi: any;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;
  ManagerList: any;
  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;
  userId: any = 0;
  clientType: any = 0;
  date: any = null;
  RouteData: any = [];
  DayPlanId: any = [];
  token:any;
  RouteDivertApproval_Form = new FormGroup({
    ManagerID: new FormControl('', [Validators.required]),
    userId: new FormControl('', [Validators.required]),
  });

  RouteDivertApprovaldataModel: RouteDivertApprovaldataModel = new RouteDivertApprovaldataModel();
  static parameters = [ApiService, Router, HttpClient, ToastrService]
  constructor(
    private apiService: ApiService, private router: Router, private http: HttpClient, private toast: ToastrService

  ) {
    let parent = this;
    this.columnDefs = [
      { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
      {
        headerName: 'Action', field: 'action', width: 150, cellRenderer: function (params) {
          var eDiv = document.createElement('div');
          eDiv.innerHTML = ` <input type="checkbox"  class="viewBtn grid_actions_item"/>  `;
          var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
          viewButton.addEventListener('change', function ($event) {
            // parent.routeId.push(params.data.RouteId)
            let e: any = $event.target;
            if (e.checked == true) {
              parent.DayPlanId.push(params.data.DayPlanId);
            }
            if (e.checked == false) {
              parent.DayPlanId.pop(params.data.DayPlanId);
            }
            // console.log('event', e.checked);
            console.log('params data ', parent.DayPlanId);
          });
          return eDiv;
        }
      },
      {
        headerName: 'Employee name', field: "Client_LegalName"
      },
      { headerName: 'Designation ', field: "ClientTypeDesc" },
      { headerName: 'Date ', field: "Route_Date" },
      { headerName: 'Route planned ', field: "PlannedRouteName" },
      { headerName: 'Route diverted ', field: "DivertRouteName" }
    ],
      this.rowHeight = 50;
    this.defaultColDefine = { resizable: true };

  }

  ngOnInit() {
    this.token = JSON.parse(sessionStorage.getItem("currentUser"));
    $('#filter-option').trigger('click');
    this.getManagerDetails();
    this.getEmpDetails();
    this.RouteDivertApprovaldataModel.ManagerID = '0';
    this.RouteDivertApprovaldataModel.userId = 0;
    var date = new Date();
    this.currentDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, "0");
    this.currentMonth = this.currentDate;

  }

  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
    this.api.hideOverlay();
  }

  ApproveDivertRoute() {
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
    // this.toast.warning("Please Select Current Month");
    if (this.DayPlanId.length == 0) {
      this.toast.warning("Please Select Employee");
    }
    else {
      this.busy = this.apiService.approvedivertedRoute_web({ data: this.DayPlanId.toString(), Id: token.id, "DivertRouteStatus": 1 }).subscribe((res: any) => {
        //this.toastr.success(res.msg);
        if (res.data.length > 0) {
          if (res.data[0].flag == 1) {
            alert(" Route Divert Approved Successfully");
            this.GetDivertFilterWise();
            this.DayPlanId = []
          }
        }
        else {
          alert(res.data[0].msg);
        }
      })
    }

  }

  RejectDivertRoute() {
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
    if (this.DayPlanId.length == 0) {
      this.toast.warning("Please Select Employee");
    }
    else {
      this.busy = this.apiService.approvedivertedRoute_web({ data: this.DayPlanId.toString(), Id: token.id, "DivertRouteStatus": 2 }).subscribe((res: any) => {
        //this.toastr.success(res.msg);
        if (res.data.length > 0) {
          if (res.data[0].flag == 1) {
            alert(" Route Divert Rejected Successfully");
            this.GetDivertFilterWise();
            this.DayPlanId = []
          }
        }
        else {
          alert(res.data[0].msg);
        }
      })
    }
  }

  onFilterTextBoxChanged() {
    this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    this.api.refreshCells();
  }


  onBtnExport() {
    this.api.exportDataAsExcel({ fileName: 'routedivertapproval' });
  }


  getManagerDetails() {
    var data = {
        Id: this.token.id
    };
    this.http.post('/api/Report/getManagerListForLogUnLog',data)
        .subscribe(res => {
            this.ManagerList = res;
        });
}


  getEmpDetails() {
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
    //  console.log('token', token);
    var data = {
      Id: token.id
    };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
      this.EmpDetails = res.data;
      console.log('empDetails', this.EmpDetails);
    })
  }
  GetDivertFilterWise() {
    //this.api.showLoadingOverlay();
   
    this.RouteDivertApprovaldataModel.empId = this.token.id;
    // let data = { userId: this.userId, date: this.date, clientType: this.clientType };
    this.busy = this.apiService.GetDivertRouteFilterWise(this.RouteDivertApprovaldataModel).subscribe((res: any) => {
      this.RouteData = res.data;
      // console.log('empDetails', this.expDetails);
    })
  }
}
